import React from "react";
import { Button } from "@glamcorner/components/lib/core/components/Button";

export const OutOfStock: React.FunctionComponent = () => {
  return (
    <div>
      <Button
        text="See similar items"
        onClick={() => {
          // Existing magento behaviour, takes you to the related products view
          const element = document.getElementById("root-style-items");
          if (element) {
            const topOffset = element.getBoundingClientRect().top + window.scrollY - 40;

            window.scrollTo({ behavior: "smooth", top: topOffset });
          }
        }}
      />
    </div>
  );
};
